import { cn } from "@/lib/utils"

export type TopSection = "catalog" | "customers" | "inventory" | "kitchen" | "orders"

export const TOP_NAV: Array<{ label: string; section: TopSection; to: string }> = [
  { label: "Kitchen", section: "kitchen", to: "/kitchen" },
  { label: "Orders", section: "orders", to: "/orders" },
  { label: "Inventory", section: "inventory", to: "/inventory" },
  { label: "Catalog", section: "catalog", to: "/catalog" },
  { label: "Customers", section: "customers", to: "/customers" },
]

const ACCENT: Record<TopSection, string> = {
  catalog: "border-amber-400 text-amber-300",
  customers: "border-violet-400 text-violet-300",
  inventory: "border-emerald-400 text-emerald-300",
  kitchen: "border-haute-cream text-haute-cream",
  orders: "border-sky-400 text-sky-300",
}

export function topNavLinkClass(section: TopSection, isActive: boolean): string {
  return cn(
    "px-3 py-4 text-sm font-medium transition-colors",
    isActive
      ? cn("border-b-2", ACCENT[section])
      : "border-b-2 border-transparent text-muted-foreground hover:text-foreground",
  )
}

export function sectionFromPath(pathname: string): TopSection {
  if (pathname.startsWith("/orders")) return "orders"
  if (pathname.startsWith("/inventory")) return "inventory"
  if (pathname.startsWith("/catalog")) return "catalog"
  if (pathname.startsWith("/customers")) return "customers"
  return "kitchen"
}

export function headerAccentClass(section: TopSection): string {
  const map: Record<TopSection, string> = {
    catalog: "border-amber-400",
    customers: "border-violet-400",
    inventory: "border-emerald-400",
    kitchen: "border-haute-cream",
    orders: "border-sky-400",
  }
  return cn("border-l-[3px] pl-3", map[section])
}

export function sidebarActiveClass(section: TopSection): string {
  const map: Record<TopSection, string> = {
    catalog: "bg-amber-400/10 text-amber-300",
    customers: "bg-violet-400/10 text-violet-300",
    inventory: "bg-emerald-400/10 text-emerald-300",
    kitchen: "bg-haute-cream/10 text-haute-cream",
    orders: "bg-sky-400/10 text-sky-300",
  }
  return map[section]
}
